// Zitat-Karussell. Jedes Zitat ist belegt (Buch, veröffentlichte Notizen oder
// Mailingliste). Keine Zitate ohne prüfbare Quelle hinzufügen.
const de = {
  items: [
    {
      text: "Beim Programmieren geht es nicht darum, was man weiß, sondern darum, was man selbst herausfinden kann.",
      name: "Chris Pine",
      role: "Autor von 'Learn to Program'",
      image: "/img/quotes/idea_lamp.webp",
    },
    {
      text: "Der einzige Weg, eine neue Programmiersprache zu lernen, ist, Programme in ihr zu schreiben.",
      name: "Brian Kernighan und Dennis Ritchie",
      role: "Autoren von 'The C Programming Language'",
      image: "/img/quotes/software.webp",
    },
    {
      text: "Jeder Dummkopf kann Code schreiben, den ein Computer versteht. Gute Programmierer schreiben Code, den Menschen verstehen.",
      name: "Martin Fowler",
      role: "Autor von 'Refactoring'",
      image: "/img/quotes/checking.webp",
    },
    {
      text: "Reden ist billig. Zeig mir den Code.",
      name: "Linus Torvalds",
      role: "Schöpfer von Linux",
      image: "/img/quotes/solving.webp",
    },
    {
      text: "Programme müssen für Menschen geschrieben werden, die sie lesen, und nur nebenbei für Maschinen, die sie ausführen.",
      name: "Harold Abelson",
      role: "Co-Autor von 'Structure and Interpretation of Computer Programs'",
      image: "/img/quotes/books.webp",
    },
    {
      text: "Die Analytische Maschine webt algebraische Muster, so wie der Jacquard-Webstuhl Blumen und Blätter webt.",
      name: "Ada Lovelace",
      role: "Die erste Programmiererin der Welt",
      image: "/img/quotes/teaching.webp",
    },
    {
      text: "Die Aufgabe guter Software ist es, das Komplexe einfach erscheinen zu lassen.",
      name: "Grady Booch",
      role: "Miterfinder der UML",
      image: "/img/quotes/tools.webp",
    },
    {
      text: "Einfachheit ist die Voraussetzung für Zuverlässigkeit.",
      name: "Edsger W. Dijkstra",
      role: "Turing-Preisträger",
      image: "/img/quotes/idea_lamp.webp",
    },
  ],
};

export default de;
